/**
 * Centralized Day.js configuration
 * @description Initializes Day.js with required plugins once at module level
 */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// Initialize all commonly used plugins once at module level
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);

// Export the configured dayjs instance
export default dayjs;
